import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--admins-form"
export default class extends Controller {
  static targets = ["form", "username", "email", "submit"]
  
  connect() {
    this.resetForm()
  }

  edit(event) {
    const row = event.currentTarget
    const id = row.dataset.id

    fetch(`/admin/admins/${id}.json`)
      .then(r => r.json())
      .then(data => {
        this.usernameTarget.value = data.username
        this.emailTarget.value = data.email
        this.formTarget.action = `/admin/admins/${id}`
        this._setMethod("patch")

        this.submitTarget.value = "Update Admin"
      })
  }

  afterSubmit(event) {
    if (!event.detail.success) return

    this.resetForm()
  }
  
  resetForm() {
    this.formTarget.reset()
    this.formTarget.action = "/admin/admins"
    this._setMethod("post")
    this.submitTarget.value = "Create Admin"
  }

  _setMethod(method) {
    let input = this.formTarget.querySelector("input[name='_method']")

    if (!input && method !== "post") {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "_method"
      this.formTarget.appendChild(input)
    }

    if (input) {
      if (method === "post") {
        input.remove()
      } else {
        input.value = method
      }
    }
  }
}
